export function brl(v) {
  const n = Number(v || 0);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function parseDec(v) {
  if (v == null || v === "") return 0;
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;

  let s = String(v)
    .trim()
    .replace(/\s/g, "")
    .replace(/R\$/gi, "")
    .replace(/[^0-9,.-]/g, "");

  if (!s) return 0;

  const negative = s.startsWith("-");
  s = s.replace(/-/g, "");

  const commaCount = (s.match(/,/g) || []).length;
  const dotCount = (s.match(/\./g) || []).length;
  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");

  if (commaCount && dotCount) {
    // Aceita tanto 1.234,56 quanto 1,234.56:
    // o último separador é tratado como decimal.
    const decimalIndex = Math.max(lastComma, lastDot);
    const integerPart = s.slice(0, decimalIndex).replace(/[.,]/g, "");
    const decimalPart = s.slice(decimalIndex + 1).replace(/[.,]/g, "");
    s = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  } else if (commaCount) {
    if (commaCount === 1) {
      s = s.replace(",", ".");
    } else {
      const decimalIndex = lastComma;
      const integerPart = s.slice(0, decimalIndex).replace(/,/g, "");
      const decimalPart = s.slice(decimalIndex + 1);
      s = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    }
  } else if (dotCount) {
    if (dotCount === 1) {
      const [integerPart, decimalPart = ""] = s.split(".");
      // Em pt-BR, "1.000" normalmente significa mil.
      // Já "119.90", "3.49" e "2.5" são tratados como decimais.
      if (integerPart !== "0" && decimalPart.length === 3) {
        s = integerPart + decimalPart;
      }
    } else {
      const parts = s.split(".");
      const allThousands = parts.slice(1).every(part => part.length === 3);
      if (allThousands) {
        s = parts.join("");
      } else {
        const decimalPart = parts.pop();
        s = `${parts.join("")}.${decimalPart}`;
      }
    }
  }

  const n = Number((negative ? "-" : "") + s);
  return Number.isFinite(n) ? n : 0;
}

export function fmtDateBR(iso) {
  if (!iso) return "—";
  const d = iso.length === 10 ? new Date(iso + "T00:00:00") : new Date(iso);
  return d.toLocaleDateString("pt-BR");
}

export function fmtTimeBR(t) {
  if (!t) return "";
  return t.slice(0, 5);
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function greeting() {
  const h = Number(
    new Intl.DateTimeFormat("pt-BR", {
      hour: "numeric",
      hour12: false,
      timeZone: "America/Sao_Paulo",
    }).format(new Date())
  );
  if (h < 12) return "Bom dia";
  if (h < 18) return "Boa tarde";
  return "Boa noite";
}

export function whatsappLink(phone, text) {
  const p = String(phone || "").replace(/\D/g, "");
  const t = encodeURIComponent(text || "");
  return `https://wa.me/${p}?text=${t}`;
}
